import $ from 'jquery'

export default {
	submit (data) {

		var config = {
			scrollTop : $(data.selector).offset().top - 300 + 'px'
		};

		$(data.target).animate(config);

		return;

	}
}


// WEBPACK FOOTER //
// ./src/components/general/scroll-to/scroll-to.js